import { RouterLink } from '@/utilities/redux-first-router.export';
import { media } from '@simplywallst/ui-core';
import { ChevronRightSolid } from '@simplywallst/ui-core/icons';
import styled from 'styled-components';

export const DiscoverMore = styled(RouterLink)`
  height: ${({ theme }) => theme.x13spacePx}px;
  display: block;
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(35, 148, 223, 0.15) 0%,
    rgba(35, 148, 223, 0.05) 100%
  );
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  text-decoration: none;
  &:hover {
    background: linear-gradient(
      180deg,
      rgba(35, 148, 223, 0.3) 0%,
      rgba(35, 148, 223, 0.1) 100%
    );
  }
`;

export const DiscoverIconWrapper = styled('div')`
  ${media.smUp`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
  `}
  svg {
    height: 98px;
    width: 98px;
  }
`;

export const DiscoverText = styled('div')`
  margin: auto 0;
`;

export const DiscoverHighlightedText = styled('span')`
  color: ${({ theme }) => theme.color.white};
`;

export const DiscoverArrowIconWrapper = styled('div')`
  margin: auto;
  display: flex;
  align-items: center;
  width: ${({ theme }) => theme.x4spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.2)};
  border-radius: 50%;
`;

export const DiscoverArrowIcon = styled(ChevronRightSolid)`
  margin: auto;
  width: ${({ theme }) => theme.x2spacePx}px;
  fill: ${({ theme }) => theme.color.brand01};
`;
